import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const configureDocTranslationRef = createTranslationRef({
  id: 'configure-doc',
  messages: {
    configureDoc: {
      cardTitle: 'Manage Docs',
      cardDescription:
        'Configure the format of docs you want to connect to the entity. No documents have been configured yet.',
      cardAction: 'Configure Docs',
      docListHeaderTitle: 'Docs',
    },
    configureDocModal: {
      modalTitle: 'Manage Docs',
      formatSectionTitle: 'Select the format',
      saveAction: 'Save',
      techDoc: {
        title: 'Markdown',
        description:
          'Write in Markdown, build with the TechDocs CLI, and keep docs up to date via CI/CD — perfect for teams who maintain documentation close to their code.',
        preRequisiteTitle: 'Prerequisites',
        preRequisiteItem1Label: 'Markdown Files',
        preRequisiteItem1Desc: 'Repository with Markdown (.md) files',
        preRequisiteItem2Label: 'Mkdocs configuration',
        preRequisiteItem2Desc:
          'mkdocs.yml configuration or compatible structure',
      },
      staticDoc: {
        title: 'Static HTML',
        description:
          'Upload prebuilt HTML docs (e.g., Doxygen, Sphinx, DocC) as .tar.gz bundles — ideal for teams using static site generators to publish ready-made docs.',
        preRequisiteTitle: 'Prerequisites',
        preRequisiteItem1Label: 'Static Site',
        preRequisiteItem1Desc: 'Prebuilt static HTML docs',
        preRequisiteItem2Label: 'Tar.gz Archive',
        preRequisiteItem2Desc: 'Bundled as .tar.gz archive',
      },
      docSetup: {
        headerTitle: 'Setup',
        stage1HeaderTitle: 'Stage 1: Configure Docs Format',
        stage1Item1Title: 'Choose your configuration',
        stage1Item1Desc:
          'Click "Save" in this form to lock in your selection. This will automatically create an annotation within your YAML file.',
        stage1Item2Title: 'Publish YAML',
        stage1Item2Desc:
          'Publish the YAML file in this workflow to your repo and register your entity (“Publish YAML File”)',
        stage2HeaderTitle: 'Stage 2: Publish Docs to XELERATE',
        stage2Item1Title: 'Auth Token',
        stage2Item1Desc:
          'Generate your auth token. It is needed to authenticate to the XELERATE Docs Publishing API.',
        stage2Item1Note:
          'You need to be part of a group in order to create an auth token.',
        stage2Item1NoteLink: 'Learn more',
        stage2Item1ActionLink: 'Create auth token',
        stage2Item2Title: 'Publish Docs',
        stage2Item2Desc:
          'Trigger the publishing process to XELERATE using your configured pipeline or the TechDocs CLI. This will build and upload your documentation.',
        stage2Item2Note:
          'You can use the XELERATE preconfigured pipeline or a local CLI',
        stage2Item2NoteLink: 'Learn more',
        stage2Item3Title: 'Verify Docs',
        stage2Item3Desc:
          'After successful entity registration open your component or system in XELERATE and ensure your documentation is correctly rendered and linked to your entity.',
      },
      confluenceDoc: {
        title: 'Confluence',
        description:
          'Use your existing Confluence pages as Docs — no migration or exports needed. Ideal for teams who want a simple, no-pipeline publishing experience.',
        preRequisiteTitle: 'Prerequisites',
        preRequisiteItem1Label: 'Access to Confluence',
        preRequisiteItem1Desc:
          'Confluence read access to the Confluence user Systemuser, Xelerate2',
        preRequisiteItem2Label: 'Valid Url',
        preRequisiteItem2Desc: 'Valid Confluence URL to your docs root page',
        confluenceInputLabel: 'Confluence URL',
        confluenceInputTooltip:
          'Enter the URL of the Confluence page or space you want to link.',
        confluenceInputPlaceholder: 'Enter the Confluence URL',
      },
    },
  },
});
